module.exports = __webpack_public_path__ + "static/media/headerImg3.bed54488.webp";